import * as yup from "yup";

export const webinarFeedbackSchema = yup.object().shape({
  feedbackRating: yup.number().required("Rating is  required").min(1),
  feedback: yup.string().required("Feedback is required"),
});
